export const locale = {
  lang: 'tr',
  data: {
    'WIZARD': {
      'TESTTITULO': 'Sihirbaz :V',
      'CARGANDO': 'Satın alınan ürünlerin yüklenmesi',
      'CARGANDO_PULSOS': 'İşlemde bakliyat yükleme',
      'SINPRODS': 'Bu ürünü alamadınız',
      'EVALUADOR':{
        'TITUTLO':'Değerlendirici'
      },
      'LANDING': {
        'PRODUCTO': {
          'CERTIFICAR': {
            'TITULO': 'CULTURAL GO Platformuna Hoşgeldiniz!',
            'CURRENT': 'Trust Index Anket Süreciniz',
            'FINISHED': 'Bu bitmiş bir sertifikalandırma işlemidir',
            'RESULTS': {
              'CURRENT': 'Sertifikalandırma işlemi bitmedi',
              // 'FINISHED': 'Bitmiş onay süreci'
              'FINISHED': 'Trust Index Anket Süreciniz',
              'FINISHED5': 'İşlem sonuçları'
            }
          },
          'Amco':{
            'TITULO': 'AMCO YA HOŞ GELDİNİZ',
            'CURRENT': 'Mevcut amco süreci budur',
            'FINISHED': 'Bu tamamlanmış bir amco sürecidir.',
            'RESULTS': {
              'CURRENT': 'Amco işlemi bitmedi',
              'FINISHED': 'Bu mevcut sonuç sürecidir',
              'FINISHED5': 'Sonuç süreci',
            }
          },
          'Trabajo_digno':{
            'TITULO': 'İYİ ÇALIŞMAYA HOŞ GELDİNİZ',
               'CURRENT': 'Şu anki insana yakışır iş süreci bu',
               'FINISHED': 'Bu tamamlanmış, insana yakışır bir iş sürecidir',
            'RESULTS': {
              'CURRENT': 'Uygun iş süreci tamamlanmadı.',
              'FINISHED': 'Bu mevcut sonuç sürecidir',
              'FINISHED5': 'Sonuç süreci'
            }
          },
          'Primer_empleo':{
            'TITULO': 'İLK İŞE HOŞ GELDİNİZ',
               'CURRENT': 'Mevcut ilk istihdam sürecidir',
               'FINISHED': 'Bu tamamlanmış bir ilk iş sürecidir.',
            'RESULTS': {
              'CURRENT': 'İlk işe alım süreci tamamlanmadı',
              'FINISHED': 'Bu mevcut sonuç sürecidir',
              'FINISHED5': 'Sonuç süreci',
            }
          },
          'CERTIFICAR_C1':{
            'TITULO': 'Hoşgeldiniz CULTURAL GO!',
            'CURRENT': 'Este é o seu processo atual de pesquisa',
            'FINISHED': 'Este é um processo de pesquisa concluído',
            'RESULTS': {
              'CURRENT': 'Processo de pesquisa não concluído',
              // 'FINISHED': 'Finished survey process'
              'FINISHED': 'Este é o seu processo atual de pesquisa',
              'FINISHED5': 'İşlem sonuçları'
            }
          },
          'CERTIFICAR_C2':{
            'TITULO': "CULTURAL GO'ya hoş geldiniz!",
            'CURRENT': 'Bu, mevcut anket sürecinizdir',
            'FINISHED': 'Bu tamamlanmış bir anket sürecidir',
            'RESULTS': {
              'CURRENT': 'Anket süreci bitmedi',
              // 'FINISHED': 'Finished survey process'
              'FINISHED': 'Bu, mevcut anket sürecinizdir',
              'FINISHED5': 'İşlem sonuçları'
            }
          },
          'CERTIFICAR_C3':{
            'TITULO': 'Hoşgeldiniz CULTURAL GO!',
            'CURRENT': 'Este é o seu processo atual de pesquisa',
            'FINISHED': 'Este é um processo de pesquisa concluído',
            'RESULTS': {
              'CURRENT': 'Processo de pesquisa não concluído',
              // 'FINISHED': 'Finished survey process'
              'FINISHED': 'Este é o seu processo atual de pesquisa',
              'FINISHED5': 'İşlem sonuçları'
            }
          },
          'CERTIFICAR_C4':{
            'TITULO': 'GÜMÜŞ SERTİFİKASINA HOŞ GELDİNİZ',
            'CURRENT': 'Este é o seu processo atual de pesquisa',
            'FINISHED': 'Este é um processo de pesquisa concluído',
            'RESULTS': {
              'CURRENT': 'Processo de pesquisa não concluído',
              // 'FINISHED': 'Finished survey process'
              'FINISHED': 'Este é o seu processo atual de pesquisa',
              'FINISHED5': 'İşlem sonuçları'
            }
          },
          'MEDIR':{
            'TITULO': 'ÖLÇÜME HOŞGELDİNİZ',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Ölçüm işlemi bitmedi',
              // 'FINISHED': 'Bitmiş ölçüm süreci'
              'FINISHED': 'Bu sizin şu anki ölçüm işleminiz',
              'FINISHED5': 'İşlem sonuçları'
            }
          },
          'MEDIR_M1':{
            'TITULO': 'GELİŞTİRİLMİŞ ÖLÇÜME HOŞGELDİNİZ',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Ölçüm işlemi bitmedi',
              'FINISHED': 'Bitmiş ölçüm süreci',
              'FINISHED5': 'İşlem sonuçları'
            }
          },
          'MEDIR_M2':{
            'TITULO': 'ÖLÇMEYE HOŞ GELDİNİZ + MST',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Ölçüm işlemi bitmedi',
              'FINISHED': 'Bitmiş ölçüm süreci'
            }
          },
          'MEDIR_M3':{
            'TITULO': 'ALANLARLA ÖLÇÜME HOŞGELDİNİZ',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Ölçüm işlemi bitmedi',
              'FINISHED': 'Bitmiş ölçüm süreci'
            }
          },
          'MEDIR_M4':{
            'TITULO': 'LİDERLERLE ÖLÇÜME HOŞGELDİNİZ',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Ölçüm işlemi bitmedi',
              'FINISHED': 'Bitmiş ölçüm süreci'
            }
          },
          'MEDIR_M5':{
            'TITULO': 'ÖLÇÜLERLE ÖLÇÜME HOŞGELDİNİZ',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Ölçüm işlemi bitmedi',
              'FINISHED': 'Bitmiş ölçüm süreci'
            }
          },
          'MEDIR_M6':{
            'TITULO': 'SERTİFİKA ÖLÇÜMÜNE HOŞGELDİNİZ',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Ölçüm işlemi bitmedi',
              'FINISHED': 'Bitmiş ölçüm süreci'
            }
          },
          'PULSE':{
            'TITULO': 'HOŞ GELDİNİZ',
              'ADMINTITULO': 'PULSE CHECK YÖNETİMİ',
            'PRODU': 'Pulse Check',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'PULSOS': 'Bu bir Darbe Kontrolü sürecidir',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'ENTRAR': 'Başlat',
            'CARGANDO_PULSE':'İşlemde nabız kontrolleri yükleniyor',
            'RESULTS': {
              'CURRENT': 'Nabız Kontrolü işlemi bitmedi',
              // 'FINISHED': 'Bitmiş Darbe Kontrolü süreci'
              'FINISHED': 'Bu sizin şu anki ölçüm işleminiz'
            }
          },
          'FOCUS':{
            'SECTION': 'Grup yöneticisi',
            'TITLE': 'Grup yöneticisi',
            'SUBTI': 'Grupların seçimi veya oluşturulması',
            'LAND': {
              'NAME': 'Anket adı',
              'INICIO': 'Başlangıç tarihi',
              'FIN': 'Hedeflenen tarih',
              'AVANCE': 'İlerlemek',
              'ESTADO': 'Durum',
              'COMP': 'Davranış',
              'CREARENC': 'Anket oluştur',
              'DELETE': 'Sil',
              'EDIT': 'Düzenle',
            },
            'TITULO': 'ODAK ALANINA HOŞGELDİNİZ',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Odak Alanı işlemi bitmedi',
              'FINISHED': 'Bitmiş Odak Alanı işlemi'
            }
          },
          'FOCUS_1':{
            'SECTION': 'Grup yöneticisi',
            'TITLE': 'Grup yöneticisi',
            'SUBTI': 'Grupların seçimi veya oluşturulması',
            'ADMINTITULO': 'YÖNETİCİ ODAK ALANLARI',
            'PRODU': 'Odak Alanı',
            'CARGANDO_FOCUS':'İşlemde odak alanı yükleniyor',
            'TAB_PROC_FOC':'Odak Alanı Süreçleri',
            'TAB_SUBIDA_COLB_FOC':'Ortak çalışan yükleme',
            'INST_MOD_FILTER_1':'Ortak çalışanlar listenizi yükleyin',
            'INST_MOD_FILTER_2':'Seçtiğiniz anketi girin',
            'LAND': {
              'NAME': 'Anket adı',
              'INICIO': 'Başlangıç tarihi',
              'FIN': 'Hedeflenen tarih',
              'AVANCE': 'İlerlemek',
              'ESTADO': 'Durum',
              'COMP': 'Davranış',
              'CREARENC': 'Anket oluştur',
              'DELETE': 'Sil',
              'EDIT': 'Düzenle',
            },
            'TITULO': 'ODAK ALANINA HOŞGELDİNİZ',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Odak Alanı işlemi bitmedi',
              'FINISHED': 'Bitmiş Odak Alanı işlemi'
            }
          },
          'MEDIR_M9':{
            'TITULO': 'INNMOTION ANKETE HOŞ GELDİNİZ',
            'CURRENT': 'Bu sizin şu anki ölçüm işleminiz',
            'FINISHED': 'Bu bitmiş bir ölçüm sürecidir',
            'RESULTS': {
              'CURRENT': 'Odak Alanı işlemi bitmedi',
              'FINISHED': 'Bitmiş Odak Alanı işlemi'
            }
          },
        },

        'DONE': 'Başvuru yılı ',
        'LEGA': 'Eski sonuçlar',
        'FOCUS': 'ANKETE ODAK ALANINA',
        'ENTRAR': 'Başlat',
        'IR':'Giriş yap',
        ////instituto turquia///
        'INST-TURQUEY':{
          'TITULO':'Kültür Özeti ve Kültür Denetimi 5.0',
          'TITULO-1':'Kültür Özeti ve Kültür Denetimi 5.0',
          'TITULO1':'Kültür Özeti ve Kültür Denetimi 5.0',
          'TITULO2':'Kültür Özeti 5.0',
           'TITULO3':'Kültür Denetimi 5.0',
           'TITULO4':'Özel Liste',

        },
        'INST-CHINA':{
          'TITULO':'Kültür Denetimi',
          'TITULO1':'Kültür Denetimi',
          'TITULO2':'Kültür Denetimi 5.0',
          'TITULO3':'Kültür Denetimi SP',
        },
        'INST-ESP':{
          'TITULO':'Kültür Denetimi',
          'TITULO1':'Kültür Denetimi',
          'TITULO2':'Kültür Denetimi 5.0',
          'TITULO3':'Hareket planı',
        }

      },
      'STEPSTAT': {
        'LOCK': 'Adım kilitlendi',
        'PEND': 'Adım aç',
        'COMP': 'Adım tamamlandı'
      },
      'NOPRODUCTS': {
        'TITULO': 'Şirketiniz satın alınmış bir ürüne sahip değildir.',
        'SUBTI': 'Teklif hakkında bilgi'
      },
      'GUIA35': {
        'TITULO': 'Kılavuz NOM-035-STPS-2018',
        'SUBTITULO':'Açıklama',
        'DESCRIPCION': 'Bilgi NOM-035-STPS-2018',
        'ENTRAR': 'BAŞLAT'

      },
      'ENCUESTA35': {
        'TITULO': 'Anketör NOM-035-STPS-2018',
        'SUBTITULO':'Açıklama',
        'DESCRIPCION': 'Aşağıdaki bölüm, işçilerin örgütsel ortamındaki farklı psikososyal risk faktörlerinin belirleneceği NOM-035-STPS-2018’nin bir anketörüne aittir.',
        'ENTRAR': 'BAŞLAT'
      },
      'Amco': {
        'TITULO': 'Amco',
      },
      'Trabajo_digno': {
             'TITULO': 'İnsana yakışır iş',
           },
           'Primer_empleo': {
             'TITULO': 'İlk iş',
           },
           'NOM35V3': {
               'TITULO': 'Norm 035 3.0'
           },
           'CERTIFICAR_C4': {
               'TITULO': 'gümüş sertifika'
           },
      'CERTIFICAR': {
        'TITULO': 'Onayla',
        'STEPS': {
          'STP1': {
            'WIZBT': 'Dil Seçenekleri',
            'TITULO': 'Dil Seçenekleri',
            'SUBTI': 'Dil seçimi'
          },
          'STP_NPS': {
            'WIZBT': 'NPS',
            'TITULO': 'NPS',
            'SUBTI': 'NPS Sürümü'
          },
          'STP1-1': {
            'WIZBT': 'Sorular',
            'TITULO': 'Sorular',
            'SUBTI': 'Soru düzenleme'
          },
          'STP1-FOCUS-PLANTILLA': {
            'WIZBT': 'Şablonlar',
            'TITULO': 'Şablonlar',
            'SUBTI': 'Soru düzenleme'
          },
          'STP2': {
            'WIZBT': 'For All Uygulamaları',
            'TITULO': 'For All Uygulamaları',
            'SUBTI': 'For All uygulamalarınızı tanımlayınız, aşağıda bilgisini vereceğiniz uygulamalar anketinizde çalışanlar tarafından değerlendirilecektir'
          },
          'STP_CONTROL': {
            'WIZBT': 'Kontrol sorusu',
            'TITULO': 'Kontrol sorusu',
            'SUBTI': 'Kontrol sorusunu düzenleme'
          },
          'STP3': {
            'WIZBT': 'Demografik Sorular',
            'TITULO': 'Demografik Sorular',
            'SUBTI': 'Anketinizde yer almasını istediğiniz demografik soruları belirleyiniz. NOT: Sarı renkli demografik özellikler isteğe bağlıdır'
          },
          'STP3-1': {
            'WIZBT': 'Açık Sorular',
            'TITULO': 'Açık Sorular',
            'SUBTI': 'Anketinizde yer almasını istediğiniz açık soruları belirleyiniz'
          },
          'STP4': {
            'WIZBT': 'Ek sorular',
            'TITULO': 'Ek sorular',
            'SUBTI': 'Ankette kullanılacak ek soruları girin'
          },
          'STP4-FOCUS-PLANTILLA': {
            'WIZBT': 'Kişiselleştirilmiş',
            'TITULO': 'Kişiselleştirilmiş',
            'SUBTI': 'Ankette kullanılacak ek soruları girin'
          },
          'STP4-1': {
            'WIZBT': 'Anket oluştur',
            'TITULO': 'Anket oluştur',
            'SUBTI': 'Anketi oluştur',
            'WIZBT2': 'Anket ',
            'TITULO2': 'Anket ',
   
          },
          'STP5': {
            'WIZBT': 'Katılımcılar',
            'TITULO': 'Katılımcılar',
            'SUBTI': 'Anket katılımcısı çalışanlarınızın verisini yükleyiniz'
          },
          'STP6': {
            'WIZBT': 'Anket Kurulumu',
            'TITULO': 'Anket Kurulumu',
            'SUBTI': 'Anket başlatma (ilk gönderim) ve hatırlatma gönderim tarihlerini giriniz'
          },
          'STP7': {
            'WIZBT': 'E-mail Gönderimleri',
            'TITULO': 'E-mail Gönderimleri',
            'SUBTI': 'Test katılımcılarına anket gönderimi yapın'
          },
          // 'STP8': {
          //   'WIZBT': 'Anket Sonlandırma',
          //   'TITULO': 'Anket Sonlandırma',
          //   'SUBTI': 'Anketin kapanışından önceki ilerleme'
          // },
          'STP8': {
            'WIZBT': 'Anket takibi',
            'TITULO': 'Anket takibi',
            'SUBTI': 'Anketin kapanışından önceki ilerleme'
          },
          'STP9': {
            'WIZBT': 'Anketi etkinleştirin',
            'TITULO': 'Anketi etkinleştirin',
            'SUBTI': 'Anketi etkinleştirin'
          },
          'STP10': {
            'WIZBT': 'Şablon',
            'TITULO': 'Şablonda değişiklik yapın',
            'SUBTI': 'Şablon'
          },
          'STP_VOICE': {
            'WIZBT': 'Ses ayarları',
            'TITULO': 'Sesli anket için ses ayarlarını yapın',
            'SUBTI': 'Sesli anket için ses ayarlarını yapın'
          }
        }
      },
      'CERTIFICARAMCO': {
        'TITULO': 'AMCO',
      },
      'CERTIFICARTRABADIG': {
        'TITULO': 'Düzgün iş',
      },
      'CERTIFICARADICPRIEMPL': {
        'TITULO': 'İlk iş',
      },
      'CERTIFICAR35': {
        'TITULO': 'NOM-035-STPS-2018',
        'LANDING': {
          'TITULO': 'NOM-035-STPS-2018 e HOŞGELDİNİZ',
          'DONE': 'Uygulama yıl',
          'ENTRAR': 'BAŞLAT'
        },
        'STEPS': {
          'STP1': {
            'WIZBT': 'Dil Seçenekleri',
            'TITULO': 'Dil Seçenekleri',
            'SUBTI': 'Dil Seçenekleri seçimi'
          },
          'STP2': {
            'WIZBT': '4ALL Uygulamaları',
            'TITULO': '4ALL Uygulamaları',
            'SUBTI': 'Anket için şirketinizin 4ALL uygulamalarını ekleyin'
          },
          'STP3': {
            'WIZBT': 'Demografik',
            'TITULO': 'Demografik',
            'SUBTI': 'Ankette gösterilecek demografik bilgileri girin'
          },
          'STP4': {
            'WIZBT': 'Additionals',
            'TITULO': 'Additionals',
            'SUBTI': 'Anket için ek sorular ekleyin'
          },
          'STP5': {
            'WIZBT': 'Katılımcılar',
            'TITULO': 'Katılımcılar',
            'SUBTI': 'Şirket ortak çalışanlarınızın veritabanını yükleyin'
          },
          'STP6': {
            'WIZBT': 'Anket Kurulumu',
            'TITULO': 'Anket Kurulumu',
            'SUBTI': 'Anketin başlatılmasını ve hatırlatılma tarihlerini zamanlayın'
          },
          'STP7': {
            'WIZBT': 'E-mail Gönderimleri',
            'TITULO': 'E-mail Gönderimleri',
            'SUBTI': 'Anket davetiyesini ortak çalışanlarınıza gönderin'
          },
          'STP8': {
            'WIZBT': 'Anket Sonlandırma',
            'TITULO': 'Anket Sonlandırma',
            'SUBTI': 'Anketin kapanışından önceki ilerleme'
          },
          'STP9':{
            'WIZBT': 'İletişim planı',
            'TITULO': 'İletişim planı',
            'SUBTI': 'Anket davetiyesini ortak çalışanlarınıza gönderin'
          },
          'STP10':{
            'WIZBT': 'Katılımcılar',
            'TITULO': 'Katılımcılar',
            'SUBTI': 'NOM035 Anketine Hazır Olun '
          }
        }
      },
      'PULSE': {
        'TITULO': 'Nabız Kontrolü',
        'LANDING': {
          'TITULO': 'HOŞ GELDİNİZ',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        },
        'STEPS': {
          // 'STP1': {
          //   'WIZBT': 'Dil Seçenekleri',
          //   'TITULO': 'Dil Seçenekleri',
          //   'SUBTI': 'Dil seçimi'
          // },
          // 'STP1-1': {
          //   'WIZBT': 'Sorular',
          //   'TITULO': 'Sorular',
          //   'SUBTI': 'Reaktif Seçimi'
          // },
          // 'STP2': {
          //   'WIZBT': 'For All Uygulamaları',
          //   'TITULO': 'For All Uygulamaları',
          //   'SUBTI': 'Şirketinizin For All uygulamalarını girin'
          // },
          // 'STP3': {
          //   'WIZBT': 'Demografik Sorular',
          //   'TITULO': 'Demografik Sorular',
          //   'SUBTI': 'Anketinizin içeriğinde kullanılacak demografi bilgilerini girin'
          // },
          // 'STP3-1': {
          //   'WIZBT': 'Açık Sorular',
          //   'TITULO': 'Açık Sorular',
          //   'SUBTI': 'Açık sorular girin'
          // },
          // 'STP4': {
          //   'WIZBT': 'Ek sorular',
          //   'TITULO': 'Ek sorular',
          //   'SUBTI': 'Ankette kullanılacak ek soruları girin'
          // },
          // 'STP5': {
          //   'WIZBT': 'Çalışanlar',
          //   'TITULO': 'Çalışanlar',
          //   'SUBTI': 'Çalışan verilerinizi yükleyin'
          // },
          'STP6': {
            'WIZBT': 'Anket tarihleri',
            'TITULO': 'Anket tarihleri',
            'SUBTI': 'Anket tarihlerini belirle'
          },
          'STP7': {
            'WIZBT': 'E-maillerin gönderimi',
            'TITULO': 'E-maillerin gönderimi',
            'SUBTI': 'Çalışanlarınıza anket daveti gönderin'
          },
          'STP8': {
            'WIZBT': 'Anket ilerlemesi',
            'TITULO': 'Anket ilerlemesi',
            'SUBTI': 'Anketlerin ilerlemesini kontrol edin Nabız Kontrolü'
          }
        }
      },

      'MEDIR': {
        'TITULO': 'Ölçüm',
        'LANDING': {
          'TITULO': 'ÖLÇÜME HOŞGELDİNİZ',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        }
      },
      'MEDIR_M1': {
        'TITULO': 'Ölçüm artırıldı',
        'LANDING': {
          'TITULO': 'GELİŞTİRİLMİŞ ÖLÇÜME HOŞGELDİNİZ',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        }
      },
      'MEDIR_M2': {
        'TITULO': 'Ölçüm + MST',
        'LANDING': {
          'TITULO': 'ÖLÇMEYE HOŞ GELDİNİZ + MST',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        }
      },
      'MEDIR_M3': {
        'TITULO': 'Alanlara göre ölçüm',
        'LANDING': {
          'TITULO': 'ALANLARLA ÖLÇÜME HOŞGELDİNİZ',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        }
      },
      'MEDIR_M4': {
        'TITULO': 'Liderlerin ölçümü',
        'LANDING': {
          'TITULO': 'LİDERLERLE ÖLÇÜME HOŞGELDİNİZ',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        }
      },
      'MEDIR_M5': {
        'TITULO': 'Boyutlara göre ölçüm',
        'LANDING': {
          'TITULO': 'ÖLÇÜLERLE ÖLÇÜME HOŞGELDİNİZ',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        }
      },
      'MEDIR_M6': {
        'TITULO': 'Onaylanacak ölçüm',
        'LANDING': {
          'TITULO': 'SERTİFİKA ÖLÇÜMÜNE HOŞGELDİNİZ',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        }
      },
      'MEDIR_M9': {
        'TITULO': 'Innmotion anketi',
        'LANDING': {
          'TITULO': 'INNMOTION ANKETE HOŞ GELDİNİZ',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        }
      },
      'FOCUS':{
        'TITULO': 'Odak alanı',
        'LANDING': {
          'TITULO': 'FOCUS ALANINA HOŞGELDİNİZ',
          'DONE': 'Uygulama yıl ',
          'ENTRAR': 'Başlat'
        },
        'STEPS': {
          'STP1': {
            'WIZBT': 'Dil Seçenekleri',
            'TITULO': 'Dil Seçenekleri',
            'SUBTI': 'Dil Seçenekleri seçimi'
          },
          'STP2': {
            'WIZBT': 'Grupları Yönet',
            'TITULO': 'Grupları Yönet',
            'SUBTI': 'Anket için şirketinizin 4ALL uygulamalarını ekleyin'
          },
          'STP3': {
            'WIZBT': 'Anketleri Yönet',
            'TITULO': 'Anketleri Yönet',
            'SUBTI': 'Ankette gösterilecek demografik bilgileri girin'
          },
          'STP4': {
            'WIZBT': 'Anket Kurulu',
            'TITULO': 'Anket Kurulu',
            'SUBTI': 'Anket için ek sorular ekleyin'
          }
        }
      },
      'LEADER_GO':{
        'TITULO_ADMIN': 'LİDER GO® HOŞ GELDİNİZ YÖNETİCİ',
        'TITULO': 'LİDER GO® HOŞ GELDİNİZ',
        'TITULO_PRODUCT':'Lider Go® yöneticisi',
        'TITULO_PRODUCT2':'Lider Go®',
        'LANDING': {
          'TITULO': 'LİDER GO YA HOŞ GELDİNİZ',
          'DONE': 'Başvuru yılı:',
          'ENTRAR': 'Başlat'
        },
        'STEPS': {
          'STP1': {
            'WIZBT': 'Diller',
            'TITULO': 'Diller',
            'SUBTI': 'Dil seçimi'
          },
          'STP2': {
            'WIZBT': 'Liderlerin seçilmesi',
               'TITULO': 'Liderlerin seçimi',
               'SUBTI': 'Seleccione los lideres',
          },
          'STP3': {
            'WIZBT': 'iletişim mesajları',
               'TITULO': 'iletişim mesajları',
               'SUBTI': 'Ingrese para editar los correos'
          },
          'STP4': {
            'WIZBT': 'Onay',
               'TITULO': 'Onay',
               'SUBTI': 'E-posta gönderimini onaylamak için girin',
          },
          'STP5': {
            'WIZBT': 'İlerleme',
               'TITULO': 'İlerleme',
               'SUBTI': 'İlerleme',
          }
        }

      },
      'ACTION_GO':{
        'TITULO_ADMIN': 'ACTION GO® HOŞ GELDİNİZ YÖNETİCİ',
        'TITULO': 'ACTION GO® HOŞ GELDİNİZ',
        'TITULO_PRODUCT':'Action GO® yöneticisi',
        'TITULO_PRODUCT2':'Action GO®',
      },
      'LANDING_REQUERIMIENTOSV3':{
          'TITULO':'Teknik gereksinimler',
          'EXTERNAL_PORTAL': 'Harici RT url\'sini kopyala',
          'COPYA_MESSAGE':'Url panoya kopyalandı',

      },
      'GOFLOW':{
        'TITULO': 'Sonuçlar GoFlow',
      },

    }
  }
};
